import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { of, switchMap } from 'rxjs';

import { LoginService } from '../login/login.service';
import { ROUTE_CONSTANTS } from '../../util/route.constants';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const loginService = inject(LoginService);

  // Keep the current page while the idle popup renews the revoked tokens.
  if (loginService.reauthenticationRequired) return of(false);

 return loginService.isLoggedIn().pipe(
  switchMap((authenticated) => handleAuthentication(authenticated, loginService, router, state))
);

function handleAuthentication(
  authenticated: boolean,
  loginService: LoginService,
  router: Router,
  state: RouterStateSnapshot
) {
  const actionMap = {
    "true": () => handleAuthenticated(loginService),
    "false": () => handleUnauthenticated(router, state),
  };
  return actionMap[String(authenticated)]?.();
}

function handleAuthenticated(loginService: LoginService) {
  if (!loginService.loggedIn$.value) {
    loginService.loggedIn$.next(true);
  }
  return of(true);
}

function handleUnauthenticated(router: Router, state: RouterStateSnapshot) {
  const redirectUrl = encodeURIComponent(state.url);
  const loginUrlTree = router.parseUrl(`${ROUTE_CONSTANTS.LOGIN}?redirectUrl=${redirectUrl}`);
  return of(loginUrlTree);
}
}
